import { useState } from 'react';

import { Loader2 } from 'lucide-react';

import TemplateListTableBody from '@/components/templates/TemplateListTableBody';
import TemplateListTableError from '@/components/templates/TemplateListTableError';
import TemplateListTableHead from '@/components/templates/TemplateListTableHead';
import TemplateListTablePagination from '@/components/templates/TemplateListTablePagination';
import { Table } from '@/components/ui/table';
import { TemplateListContext } from '@/contexts/TemplatesContext';
import { useTemplates } from '@/hooks/useTemplatesAPI';
import PageLayout from '@/layouts/PageLayout';

const TemplateListPage = () => {
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const { templates, loading, error, refetch } = useTemplates({
    sortBy,
    sortDirection,
  });

  const totalPages = Math.ceil(templates.length / itemsPerPage);

  return (
    <TemplateListContext.Provider
      value={{
        currentPage,
        error,
        itemsPerPage,
        refetch,
        setCurrentPage,
        setSortBy,
        setSortDirection,
        sortBy,
        sortDirection,
        templates,
        totalPages,
      }}
    >
      <PageLayout subtitle="Existing templates" title="Templates">
        {loading && (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-8 w-8 animate-spin" />
            <span className="ml-2">Loading templates...</span>
          </div>
        )}
        {error && !loading && <TemplateListTableError />}
        {!loading && !error && (
          <div className="rounded-md border">
            <Table>
              <TemplateListTableHead />
              <TemplateListTableBody />
            </Table>
            {totalPages > 1 && <TemplateListTablePagination />}
          </div>
        )}
      </PageLayout>
    </TemplateListContext.Provider>
  );
};

export default TemplateListPage;
